import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'services/printer.service';
import { useAlert } from 'context/AlertProvider';

export const ZebraContext = React.createContext(null);

export default function ZebraProvider({ children, autoConnect = true }) {
  const alert = useAlert();
  const [zebra, setZebra] = useState();

  useEffect(() => {
    if (!autoConnect) return;

    connect()
      .then((printer) => {
        if (printer.uid) {
          setZebra(printer);
        } else {
          alert.current.error(
            'No se ha encontrado una impresora por defecto configurada, por favor configure una en Browser Print y vuelva a intentarlo.',
          );
        }
      })
      .catch((error) => {
        console.error(error);
        if (alert.current)
          alert.current.error(
            'Ha ocurrido un error conectando con la impresora, revise que Browser Print este en marcha y configurado e inténtelo de nuevo.',
          );
      });
  }, [setZebra, alert, autoConnect]);

  return (
    <ZebraContext.Provider value={zebra}>{children}</ZebraContext.Provider>
  );
}

export function useZebra() {
  return useContext(ZebraContext);
}
